import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaKaggle, FaLinkedin, FaYoutube } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a
        href="https://github.com/R1SE23"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BsGithub />
      </a>
    </div>
    <div>
      <a
        href="https://www.kaggle.com/risenattarach"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaKaggle />
      </a>
    </div>
    <div>
      <a
        href="https://www.linkedin.com/in/nattarach-rise/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaLinkedin />
      </a>
    </div>
    <div>
      <a
        href="https://youtu.be/M2ROKsylZ2s"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaYoutube />
      </a>
    </div>
  </div>
);

export default SocialMedia;
